import { get } from "../helpers/config";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export const useFetchUserAccount = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("useraccount/list");
    }, options);
};